import { render, staticRenderFns } from "./MarketsCurrencyPairsFilters.vue?vue&type=template&id=13000374&"
import script from "./MarketsCurrencyPairsFilters.vue?vue&type=script&lang=js&"
export * from "./MarketsCurrencyPairsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports